<template>
    <div class="card">
        <div class="card-content">
            <b-message type="is-info">
                <div class="columns">
                    <!-- <div class="column">
                        <b>Dotación:</b> {{this.bed.length}}                    
                    </div> -->
                    <div class="column">
                        <b>Habilitadas:</b> {{ this.bed.filter(e=>(e.state=='HABILITADA')).length }}                    
                    </div>
                    <div class="column">
                        <b>Disponibles:</b> {{ this.bed.filter(e=>(e.patient_id==null && e.state=='HABILITADA')).length }}                    
                    </div>
                    <div class="column">
                        <b>Con pacientes:</b> {{ this.bed.filter(e=>e.patient_id!==null && e.state=='HABILITADA').length }}                    
                    </div>
                    <div class="column">
                        <b>Con covid:</b> {{ this.bed.filter(e=>e.covid19=='positivo' && e.state=='HABILITADA').length }}                    
                    </div>
                    <div class="column">
                        <b>Con ventilador:</b> {{ this.bed.filter(e=>e.ventilator_used=='si' && e.state=='HABILITADA').length }}                    
                    </div>
                </div>
            </b-message>
        </div>
    </div>
</template>
<script>  
  export default {
    props: ["bed"],
    methods: {
     
    },
  };
</script>